import React, { useEffect, useState } from "react";
import './TermsAndConditions.css';
import { useLanguage } from "../../context/LanguageContext/LanguageContext";

const TermsAndConditions = () => {
  const [termsContent, setTermsContent] = useState([]);
  const { translations, direction, language } = useLanguage();
  const t = translations; // Translation object from context

  useEffect(() => {
    const termsSections = [
      {
        heading: t.introductionHeading, // Use translation
        content: t.introductionContent, // Use translation
      },
      {
        heading: t.intellectualPropertyHeading, // Use translation
        content: t.intellectualPropertyContent, // Use translation
      },
      {
        heading: t.restrictionsHeading, // Use translation
        content: t.restrictionsContent, // Use translation
        list: [
          t.restriction1, // Use translation
          t.restriction2, // Use translation
          t.restriction3, // Use translation
          t.restriction4, // Use translation
        ],
      },
      {
        heading: t.limitationOfLiabilityHeading, // Use translation
        content: t.limitationOfLiabilityContent, // Use translation
      },
      {
        heading: t.amendmentsHeading, // Use translation
        content: t.amendmentsContent, // Use translation
      },
      {
        heading: t.governingLawHeading, // Use translation
        content: t.governingLawContent, // Use translation
      },
    ];

    setTermsContent(termsSections);
  }, [t]); // Re-run if translations change

  return (
    <div className="terms-container">
      <h1>{t.termsAndConditions}</h1> {/* Use translation */}
      <div className="terms-content">
        {termsContent.map((section, index) => (
          <div key={index} className="terms-section">
            <h2>{section.heading}</h2>
            <p>{section.content}</p>
            {section.list && (
              <ul>
                {section.list.map((item, idx) => (
                  <li key={idx}>
                    <div className="lineColorBlue"></div>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsAndConditions;
